import { darken, lighten } from '@mui/material/styles';

export const getFont = (fontName) => {
    const fonts = {
        'Comic Sans': '"Comic Sans MS", "Comic Sans"',
        'Arial': '"Arial", sans-serif',
        'Courier New': '"Courier New", Courier, monospace',
        'Georgia': '"Georgia", serif',
        'Helvetica': '"Helvetica", sans-serif',
        'Inter': '"Inter", sans-serif',
        'Montserrat': '"Montserrat", sans-serif',
        'Noto Sans': '"Noto Sans", sans-serif',
        'Open Sans': '"Open Sans", sans-serif',
        'Roboto': '"Roboto", sans-serif',
        'Tahoma': '"Tahoma", sans-serif',
        'Times New Roman': '"Times New Roman", Times, serif',
        'Trebuchet MS': '"Trebuchet MS", sans-serif',
        'Verdana': '"Verdana", sans-serif',
        'Evolventa': '"Evolventa", sans-serif',
    };
    return fonts[fontName?.trim()] || null;
};

export const createUserTheme = (widgetData = {}, refreshBite = 0) => (theme = {}) => {
    const font = getFont(widgetData?.font) || '"Roboto", sans-serif';

    return {
        shape: {
            window: widgetData?.rounding?.window || 8,
            button: widgetData?.rounding?.button || 8,
        },
        typography: {
            ...theme.typography,
            fontFamily: font + ' !important',
        },
        palette: {
            ...theme.palette,
            primary: {
                ...theme?.palette?.primary,
                main: widgetData?.colors?.window?.background_message || '#1976d2',
                light: lighten(widgetData?.colors?.window?.background_message || '#1976d2', 0.8),
                text: widgetData?.colors?.window?.content || '#000',
                background: widgetData?.colors?.window?.background || '#fff',
            },
            header: {
                ...theme?.palette?.header,
                main: widgetData?.colors?.header_and_copyright?.background || '#f5f5f5',
                text: widgetData?.colors?.header_and_copyright?.content || '#000',
                light: lighten(widgetData?.colors?.header_and_copyright?.background || '#f5f5f5', 0.8),
            },
            button: {
                ...theme?.palette?.button,
                borderRadius: widgetData?.rounding?.button || 8,
                main: widgetData?.colors?.button?.background || '#1976d2',
                icon: widgetData?.colors?.button?.icon || '#fff',
            },
            text: {
                ...theme?.palette?.text,
                dark: widgetData?.colors?.window?.content || '#000',
            },
            grey: {
                ...theme?.palette?.grey,
                dark: widgetData?.colors?.window?.content || '#666',
            },
        },
        components: {
            ...theme?.components,
            MuiCircularProgress: {
                ...theme?.components?.MuiCircularProgress,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiCircularProgress?.styleOverrides?.root,
                        color: widgetData?.colors?.header_and_copyright?.background || '#1976d2',
                    },
                },
            },
            MuiInputBase: {
                ...theme?.components?.MuiInputBase,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiInputBase?.styleOverrides?.root,
                        borderRadius: '5px',
                        fontFamily: font,
                    },
                },
            },
            MuiBox: {
                ...theme?.components?.MuiBox,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiBox?.styleOverrides?.root,
                        fontFamily: font,
                    },
                },
            },
            MuiFormLabel: {
                ...theme?.components?.MuiFormLabel,
                styleOverrides: {
                    root: {
                        fontFamily: font,
                    },
                },
            },
            MuiFormControl: {
                ...theme?.components?.MuiFormControl,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiFormControl?.styleOverrides?.root,
                        borderRadius: '5px',
                        fontFamily: font,
                    },
                },
            },
            MuiButton: {
                ...theme?.components?.MuiButton,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiButton?.styleOverrides?.root,
                        borderRadius: '5px',
                        backgroundColor: widgetData?.colors?.header_and_copyright?.background || '#1976d2',
                        color: widgetData?.colors?.button?.icon || '#fff',
                        fontFamily: font,
                        '&:hover': {
                            backgroundColor: darken(widgetData?.colors?.header_and_copyright?.background || '#1976d2', 0.2),
                        },
                    },
                },
            },
            MuiTypography: {
                ...theme?.components?.MuiTypography,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiTypography?.styleOverrides?.root,
                        color: widgetData?.colors?.window?.content || '#000',
                        fontFamily: font,
                    },
                },
            },
            MuiButtonBase: {
                ...theme?.components?.MuiButtonBase,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiButtonBase?.styleOverrides?.root,
                        color: widgetData?.colors?.window?.content || '#000',
                        fontFamily: font,
                    },
                },
            },
            MuiChip: {
                ...theme?.components?.MuiChip,
                styleOverrides: {
                    root: {
                        ...theme?.components?.MuiChip?.styleOverrides?.root,
                        color: widgetData?.colors?.window?.content || '#000',
                        borderColor: widgetData?.colors?.window?.content || '#000',
                    },
                },
            },
        },
    };
};
